import { fyLabel } from '../../../utils/subscriptionFyUtils'

export type SubscriptionFySelectValue = number | 'all'

interface SubscriptionFySelectProps {
	value: SubscriptionFySelectValue
	options: number[]
	onChange: (value: SubscriptionFySelectValue) => void
	id?: string
}

export function SubscriptionFySelect({
	value,
	options,
	onChange,
	id = 'subscription-fy-select',
}: SubscriptionFySelectProps) {
	const selectValue = value === 'all' ? 'all' : String(value)
	return (
		<div className="flex items-center gap-2">
			<label
				htmlFor={id}
				className="text-xs font-semibold text-slate-600 whitespace-nowrap"
			>
				Financial year
			</label>
			<select
				id={id}
				value={selectValue}
				onChange={e => {
					const v = e.target.value
					onChange(v === 'all' ? 'all' : Number(v))
				}}
				className="text-xs font-semibold text-slate-800 border border-slate-200 rounded-lg px-2.5 py-1.5 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
			>
				<option value="all">All FY</option>
				{options.map(y => (
					<option key={y} value={String(y)}>
						{fyLabel(y)}
					</option>
				))}
			</select>
		</div>
	)
}
